module.exports = __webpack_public_path__ + "static/media/AirbnbCerealApp-ExtraBold.fdfdd4b6.woff";